module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/lock-9c3cfe8c8c65a27e53a24e1120f6074c.svg";